import { SpinnerService } from './services/spinner.service';
import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'maint-app';
  constructor(private spinnerService: SpinnerService) {
  }
}
